module.exports = __webpack_public_path__ + "static/media/custom_logo_topic.6e104bf1.png";